import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { FreemiumAPIService } from 'src/app/webtree-website/freemium-api.service';
import { FreemiumJdData, FreemiumParams } from 'src/app/webtree-website/freemiumParams';
// import { FreemiumJdData } from '../freemiumParams';
import { interval } from 'rxjs';
import { FreemiumService } from 'src/app/webtree-website/freemium.service';
import { UntypedFormControl } from '@angular/forms';
import { FreemiumConstants } from 'src/app/webtree-website/freemiumConstants';
// import { WebbtreeJdSearchFilterModalComponent } from '../webbtree-jd-search-filter-modal/webbtree-jd-search-filter-modal.component';
// import { FreemiumAPIService } from '../freemium-api.service';
import _ from 'underscore';

@Component({
    selector: 'app-skilltaxonomy-loader',
    templateUrl: './skilltaxonomy-loader.component.html',
    styleUrls: ['./skilltaxonomy-loader.component.scss'],
    standalone: false
})
export class SkilltaxonomyLoaderComponent implements OnInit {

  @Input() dataFromParent
  @Input() description = "";
  @Output() dataEmitter : EventEmitter<any> = new EventEmitter();
jobTitleSelectedList: any[] = [];
  filterData: FreemiumParams;
  showregion: string = 'asia';
  tabName: string;

  skillsSelectedList: any[] = [];
    locationInput: UntypedFormControl = new UntypedFormControl(null);
    locationTitleList: any[] = [];
    locationSelectedList: any[] = [];
  recomendResponse:any
  skillsData:any
  jobtitleData:any
  skilltaxonomyChart:any
  messageForSendEmail:any
  private jdResponse: FreemiumJdData = null;
  successMessage: string = '';
  errorMessage: string = '';

  constructor(
    private activeModal: NgbActiveModal, private searchtoolbox: SearchtoolboxService, private modalService: NgbModal, private freemiumApiService: FreemiumAPIService, private freemiumService:FreemiumService
  ) { }

  ngOnInit() {
    this.dataFromParent
     this.increaseProgress();
    }

  progressValue: number = 0;

  increaseProgress() {
    const interval$ = interval(500); // Change interval duration as needed
    const subscription = interval$.subscribe(() => {
      this.progressValue += 10;
      if (this.progressValue >= 80) {
        this.progressValue = this.skilltaxonomyChart ? 100 : 99;
      }
      if (this.progressValue === 100) {
        subscription.unsubscribe();
        setTimeout(() => {
           this.dataEmitter.emit('close');
          this.activeModal.close(this.jdResponse);
      }, 500);

      }
    });

    // this.dataFromParent &&this.freemiumApiService.freemiumParseJobDescription(this.dataFromParent).subscribe((res: FreemiumJdData) => {
    //   this.jdResponse = res;
    //       this.dataEmitter.emit(this.jdResponse);
    // });
    this.getSkills()
  }
  getSkills() {
      let aggReq = this.freemiumService.getRequestWithFilters();
        Object.assign(aggReq, {
        aggregatetype: 'skills',
        aggregatescount: 50
      });
      delete aggReq.resultsize
      this.freemiumApiService.getFreemiumTotalAggs(aggReq).subscribe(res=>{
        this.skillsData = res.data.aggregations.skills
        this.getJobTitle()
      })

  }
  getJobTitle(){
    let aggReq = this.freemiumService.getRequestWithFilters();
        Object.assign(aggReq, {
        aggregatetype: 'current_jobtitle',
        aggregatescount: 50
      });
      this.freemiumApiService.getFreemiumTotalAggs(aggReq).subscribe(res=>{
        this.jobtitleData = res.data.aggregations.current_jobtitle
        this.jobtitleData = _.pluck(this.jobtitleData, 'key');
        this.getSkillsTaxonomy()

      })
  }
    getQuickSearchData(){

      this.freemiumService.setQuickSearchData(this.dataFromParent);
      this.freemiumApiService.getFreemiumRecommendData(this.dataFromParent).subscribe(response=>{
        this.recomendResponse = response;
        this.dataEmitter.emit(this.recomendResponse)
      })

    }
    getSkillsTaxonomy(){
      if(this.skillsData.length > 50) {
      this.skillsData = this.skillsData.slice(0, 50);
    }
    const payload = {
      jobtitles: this.jobtitleData,
      skills: this.skillsData.map(skill => {
        return {
          skill_name: skill.key,
          skill_count: skill.doc_count
        }
      })
    }
    this.freemiumApiService.getfreemiumSkillsTaxonomy(payload).subscribe((res:any)=>{
      if(res.status == "success") {
      this.skilltaxonomyChart = res.data;
      this.messageForSendEmail =res.message
        this.dataEmitter.emit({status:'close', data:  this.skilltaxonomyChart, message:this.messageForSendEmail});
      } else {
        this.errorMessage = "We couldn’t generate the skill taxonomy right now. Refresh and try again."
        setTimeout(()=>{
          this.errorMessage = '';
        }, 3000);
        this.dataEmitter.emit({status:'close', data:null, message:null});

      }

    }, (err)=>{
        this.errorMessage = "We couldn’t generate the skill taxonomy right now. Refresh and try again."
        setTimeout(()=>{
          this.errorMessage = '';
          this.dataEmitter.emit({status:'close', data:null, message:null});

        }, 3000);
    })
    }
}
